export default "__VITE_ASSET__CJKM59kp__"